module.exports = __webpack_public_path__ + "static/media/4_14.58b9f246.png";